import { Indices } from "../types";

export const getKeyFromIndices = (indices: Indices) =>
  `(${indices[0]},${indices[1]},${indices[2]})`;
